import { PropsWithChildren } from "react";
import { SortedBy } from "./useSorting";

export type TableProps = PropsWithChildren<{
  rows?: Array<{
    [key: string]: any;
  }>;
  columns: InputColumn[];
  isServerSideSort?: boolean;
  showControls?: boolean;
  controlsAtBottom?: boolean;
  showPagination?: boolean;
  sortDirection?: SortOrder;
  defaultSort?: Omit<SortedBy, "direction"> & {
    direction: SortOrder.Asc | SortOrder.Desc | SortOrder.None;
  };
  tableIsNotSortable?: boolean;
  tableIsSmall?: boolean;
  removeColumnHeaderBorder?: boolean;
  smallTableHeaders?: boolean;
  boldTableHeaders?: boolean;
  underlineTableHeaders?: boolean;
  flexibleColumnsSectionMaxWidth?: number;
  hyperLinkTextDecorationStyle?: "solid" | "dotted"
  rowHeightMultiplyer?: number[]; // no longer used
  filename?: string;
  exportIconColor?: string;
  noSticky?: boolean;
  allowRowHighlighting?: boolean;
  customSort?: (a: any, b: any) => number;
}>;

// values the user can specify
export type InputColumn = {
  key: string;
  sortDirection?: SortOrder;
  firstSort?: SortOrder.Asc | SortOrder.Desc;
  isFixed?: boolean;
  alignLeft?: boolean;
  isNotSortable?: boolean;
  label: string;
  labelTip?: string;
  data?: any[];
  subData?: any[];
  tooltips?: string[];
  customSort?: (a: any, b: any) => number;
  onHeaderClick?: (key: string, currentDirection: SortOrder, notSortable: boolean, firstSort: SortOrder) => any,
  mapData?: (label: any, row: { [key: string]: any }) => any;
  mapSubData?: (label: any, row: { [key: string]: any }) => any;
}

// internal representation of a column
export type Column = {
  key: string;
  sortDirection?: SortOrder;
  firstSort?: SortOrder.Asc | SortOrder.Desc;
  isFixed?: boolean;
  alignLeft?: boolean;
  isNotSortable?: boolean;
  label: string;
  labelTip?: string;
  onHeaderClick?: (key: string, currentDirection: SortOrder, notSortable: boolean, firstSort: SortOrder) => any,
  customSort?: (a: any, b: any) => number;
  data?: Array<{
    i: number,
    val: any,
    display: any,
    subData?: any[],
    subDisplay?: any[],
    tooltip?: string,
    hash: string,
  }>;
  mapData?: (label: any, row: { [key: string]: any }) => any;
  mapSubData?: (label: any, row: { [key: string]: any }) => any;

};

export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
  None = "none",
}
